import { LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { LatestNewsCard } from '../../types';
import { translateFn } from '../../../../../utils/translator.helper';
import { FontSizes, FontWeights } from '../../../../../types/common/types';
import { GzLandingPageCompanyType } from '../../../../../landingPage/types';
import { getLandingPageReference } from '../../../../../landingPage/utils';

export type CardColor = 'white' | 'primary';

/**
 * @summary Type here the description of this component
 * @tag gz-latest-news-card-widget
 * Here https://custom-elements-manifest.open-wc.org/analyzer/getting-started/ you can find out how to document the code
 */
@customElement('gz-latest-news-card-widget')
export class LatestNewsCardWebComponent extends LitElement implements LatestNewsCard {
  @property({ type: Number })
  companyType: GzLandingPageCompanyType;

  @property({ type: String, reflect: true })
  postTitle: string;

  @property({ type: String, reflect: true })
  summary: string;

  @property({ type: String, reflect: true })
  imageUrl: string;

  @property({ type: String, reflect: true })
  tag: string;

  @property({ type: String, reflect: true })
  postUrl: string;

  @property({ type: String, reflect: true })
  cardColor: CardColor = 'white';

  @property({ type: Number })
  index: number;

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    return html`
      <div class="card--wrapper">
        <span class="card--tag">${this.tag}</span>
        <div class="card--image" style="background-image: url('${this.imageUrl}')"></div>
        <div class="card--content">
          <gz-title
            id="news-card-${this.index}-title"
            fontSize=${FontSizes.TITLE}
            fontWeight=${FontWeights.MEDIUM}
            class="card--title"
            ><span>${this.postTitle}</span></gz-title
          >
          <gz-text
            id="news-card-${this.index}-summary"
            fontSize=${FontSizes.HEADING_6}
            class="card--intro"
            ><span>${this.summary}<span></gz-text
          >
        </div>
        <div class="card--footer">
          <gz-button
            id="news-card-${this.index}-read-more-button"
            type="outline"
            theme="${this.cardColor === 'primary' ? 'dark' : 'light'}"
            color="${this.cardColor === 'primary' ? 'white' : 'secondary'}"
            @click="${() => this.goToNewsUrl(this.postUrl, this.postTitle)}"
            >${translateFn('Read More')}</gz-button
          >
        </div>
      </div>
    `;
  }

  private goToNewsUrl(postUrl: string, postTitle: string) {
    const postTitleKebabCase = postTitle.toLowerCase().replace(/\s/g, '-');
    const link = postUrl + `?icid=button|b|${getLandingPageReference(this.companyType)}|${postTitleKebabCase}`;

    window.open(link, '_blank');
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-latest-news-card-widget': LatestNewsCardWebComponent;
  }
}
